import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ShareOptions from './ShareOptions';
import ScrambledText from './ScrambledText';

const Preloader = ({
  referralHash, isLoading, arcsQuotaPerReferrer, isMobile,
}) => {
  // const [isVanillaAnimationCompleted, setAnimationState] = useState(false);
  // const isProcessing = (!referralHash && isLoading);

  if (!referralHash && isLoading) {
    return <ScrambledText />;
  }

  // if (!isManual && !isVanillaAnimationCompleted) {
  //   return <ScrambledText onAnimationCompleted={setAnimationState} />;
  // }

  if (referralHash) {
    return (
      <ShareOptions
        isMobile={isMobile}
        arcsQuotaPerReferrer={arcsQuotaPerReferrer}
        referralHash={referralHash}
      />
    );
  }

  // if (isProcessing) {
  //   return <ScrambledText shouldAnimate={false} />;
  // }

  return null;
};

Preloader.propTypes = {
  referralHash: PropTypes.string,
  // isManual: PropTypes.bool,
  isLoading: PropTypes.bool,
  arcsQuotaPerReferrer: PropTypes.number,
  isMobile: PropTypes.bool,
};

export default memo(Preloader);
